import a from "./index.es473.js";
import { FORMAT_ID_STARTS_FROM as k } from "./index.es475.js";
function h(t, e) {
  var r = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r) return (r = r.call(t)).next.bind(r);
  if (Array.isArray(t) || (r = L(t)) || e) {
    r && (t = r);
    var l = 0;
    return function() {
      return l >= t.length ? { done: !0 } : { done: !1, value: t[l++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function L(t, e) {
  if (t) {
    if (typeof t == "string") return O(t, e);
    var r = {}.toString.call(t).slice(8, -1);
    return r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set" ? Array.from(t) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? O(t, e) : void 0;
  }
}
function O(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, l = Array(e); r < e; r++) l[r] = t[r];
  return l;
}
function et(t) {
  var e = t.formats, r = t.styles, l = t.fonts, A = t.fills, C = t.borders, o = '<?xml version="1.0" ?>';
  if (o += '<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">', e.length > 0) {
    o += '<numFmts count="'.concat(e.length, '">');
    for (var c = 0; c < e.length; c++)
      o += '<numFmt numFmtId="'.concat(k + c, '" formatCode="').concat(a(e[c]), '"/>');
    o += "</numFmts>";
  }
  o += '<fonts count="'.concat(l.length, '">');
  for (var V = h(l), T; !(T = V()).done; ) {
    var i = T.value, X = i.size, B = i.family, R = i.color, H = i.weight, N = i.style, q = i.custom;
    o += "<font>", o += '<sz val="'.concat(X, '"/>'), o += "<color ".concat(R ? 'rgb="' + a(S(R)) + '"' : 'theme="1"', "/>"), o += '<name val="'.concat(a(B), '"/>'), o += '<family val="2"/>', q || (o += '<scheme val="minor"/>'), H === "bold" && (o += "<b/>"), N === "italic" && (o += "<i/>"), o += "</font>";
  }
  o += "</fonts>", o += '<fills count="'.concat(A.length, '">');
  for (var G = h(A), U; !(U = G()).done; ) {
    var _ = U.value, j = _.color, J = _.gray125;
    o += "<fill>", j ? (o += '<patternFill patternType="solid">', o += '<fgColor rgb="'.concat(a(S(j)), '"/>'), o += '<bgColor indexed="64"/>', o += "</patternFill>") : J ? o += '<patternFill patternType="gray125"/>' : o += '<patternFill patternType="none"/>', o += "</fill>";
  }
  o += "</fills>", o += '<borders count="'.concat(C.length, '">');
  for (var K = h(C), z; !(z = K()).done; ) {
    var f = z.value, P = f.left, Q = f.right, W = f.top, Y = f.bottom, d = function(p, E) {
      var y = E.style, g = E.color;
      g && !y && (y = "thin");
      var M = !!g;
      return "<".concat(p) + (y ? ' style="'.concat(a(y), '"') : "") + (M ? ">" : "/>") + (g ? '<color rgb="'.concat(a(S(g)), '"/>') : "") + (M ? "</".concat(p, ">") : "");
    };
    o += "<border>", o += d("left", P), o += d("right", Q), o += d("top", W), o += d("bottom", Y), o += "<diagonal/>", o += "</border>";
  }
  o += "</borders>", o += '<cellXfs count="'.concat(r.length, '">');
  for (var Z = h(r), D; !(D = Z()).done; ) {
    var n = D.value, b = n.fontId, F = n.fillId, x = n.borderId, s = n.align, u = n.alignVertical, v = n.textRotation, m = n.indent, I = n.wrap, w = n.formatId;
    o += "<xf " + [
      w !== void 0 ? 'numFmtId="'.concat(w, '"') : void 0,
      w !== void 0 ? 'applyNumberFormat="1"' : void 0,
      b !== void 0 ? 'fontId="'.concat(b, '"') : void 0,
      b !== void 0 ? 'applyFont="1"' : void 0,
      F !== void 0 ? 'fillId="'.concat(F, '"') : void 0,
      F !== void 0 ? 'applyFill="1"' : void 0,
      x !== void 0 ? 'borderId="'.concat(x, '"') : void 0,
      x !== void 0 ? 'applyBorder="1"' : void 0,
      s || u || v || m || I ? 'applyAlignment="1"' : void 0
      // 'xfId="0"'
    ].filter(function(p) {
      return p;
    }).join(" ") + ">" + // Possible horizontal alignment values:
    //  left, center, right, fill, justify, center_across, distributed.
    // Possible vertical alignment values:
    //  top, vcenter, bottom, vjustify, vdistributed.
    // https://xlsxwriter.readthedocs.io/format.html#set_align
    (s || u || v || m || I ? "<alignment" + (s ? ' horizontal="'.concat(a(s), '"') : "") + (u ? ' vertical="'.concat(a(u), '"') : "") + (v ? ' textRotation="'.concat(tt($(v)), '"') : "") + (m ? ' indent="'.concat(a(String(m)), '"') : "") + (I ? ' wrapText="1"' : "") + "/>" : "") + "</xf>";
  }
  return o += "</cellXfs>", o += "</styleSheet>", o;
}
function S(t) {
  if (t[0] !== "#")
    throw new Error('Color "'.concat(t, '" must start with a "#"'));
  return "FF".concat(t.slice(1).toUpperCase());
}
function $(t) {
  if (!(t >= -90 && t <= 90))
    throw new Error("Unsupported text rotation angle: ".concat(t, ". Values from -90 to 90 are supported."));
  return t;
}
function tt(t) {
  return t < 0 ? 90 - t : t;
}
export {
  et as default
};
//# sourceMappingURL=index.es433.js.map
